import { howlerSFXPlayer } from 'js/components/audio/howler';

export const APP_PAGES_DATA = '[APP] APP_PAGES_DATA';
export const APP_START_FRONTEND = '[APP] APP_START_FRONTEND';
export const APP_SET_METADATA = '[APP] APP_SET_METADATA';
export const APP_SET_COOKIE_CHOICE = '[APP] APP_SET_COOKIE_CHOICE';
export const APP_SET_LOCALE = '[APP] APP_SET_LOCALE';
export const APP_SET_LOCALISATION = '[APP] APP_SET_LOCALISATION';
export const APP_TOGGLE_ACTIVITY_CARD_FOCUS = '[APP] APP_TOGGLE_ACTIVITY_CARD_FOCUS';
export const APP_RELEASE_ACTIVITY_CARD_FOCUS = '[APP] APP_RELEASE_ACTIVITY_CARD_FOCUS';
export const TRACK_PREV_PAGE = '[APP] TRACK_PREV_PAGE';
export const TOGGLE_MODAL_OVERLAY = '[APP] TOGGLE_MODAL_OVERLAY';
export const TOGGLE_ONLINE_STATUS = '[APP] TOGGLE_ONLINE_STATUS';

export const toggleOnlineStatus = (isOnline) => ({
  type: TOGGLE_ONLINE_STATUS,
  payload: isOnline,
});

export const startFrontend = (data) => ({
  type: APP_START_FRONTEND,
  payload: data,
});

export const setMetadata = (data) => ({
  type: APP_SET_METADATA,
  payload: data,
});

export const setPagesData = (data) => ({
  type: APP_PAGES_DATA,
  payload: data,
});

export const COOKIE_CHOICE = {
  ACCEPT: 'ACCEPT',
  REJECT: 'REJECT',
};

export const setCookieChoice = (data) => ({
  type: APP_SET_COOKIE_CHOICE,
  payload: data,
});

export const setLocale = (data) => ({
  type: APP_SET_LOCALE,
  payload: data,
});

export const setLocalisation = (data) => ({
  type: APP_SET_LOCALISATION,
  payload: data,
});

export const toggleActivityCardFocus = (data) => ({
  type: APP_TOGGLE_ACTIVITY_CARD_FOCUS,
  payload: data,
});

export const trackPrevPage = (data) => ({
  type: TRACK_PREV_PAGE,
  payload: data,
});

export const releaseActivityCardFocus = (action) => ({
  type: APP_RELEASE_ACTIVITY_CARD_FOCUS,
  payload: action,
});

export const toggleModalOverlay = (data) => {
  return {
    type: TOGGLE_MODAL_OVERLAY,
    payload: data,
  };
};

export const playSFX = (key, volume = 0.5) => {
  return (dispatch, getState) => {
    if (!isAudioActive(getState())) return;
    howlerSFXPlayer.play(key, volume);
  };
};
